import { combineReducers } from 'redux'
import { userLogin } from './user.redux'
import { alertStatus } from './alert.redux'
export default combineReducers({userLogin, alertStatus})
